import Index from './Index';
import Show from './Show';
import {
  Switch,
  Route,
  useRouteMatch,
} from "react-router-dom";

let Drivers = (props) => {
  let { path } = useRouteMatch();
  const theme = props.theme;

  return <>
    <Switch>
      <Route exact path={`${path}`}>
        <Index theme={theme} setShowMenu={props.setShowMenu} />
      </Route>
      <Route exact path={`${path}/:exit_id`}>
        <Show theme={theme}/>
      </Route>
    </Switch>
  </>
}

export default Drivers;
